import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@material-ui/icons/School";
import WorkIcon from "@material-ui/icons/Work";
import "@material-ui/icons";
import { BorderColor, Computer, DevicesOther } from "@material-ui/icons";
import "../styles/Experience.css"; 
import {motion} from "framer-motion"


function Experience() {
  return (
    <div className="experience">
      <VerticalTimeline lineColor="#b59e1f">

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2023 - 5/2025"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          Product Management 
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            RPM Stealth Startup | Los Angeles, California USA
          </h4>
          <ul>
                <li>Led product research, user discovery, and vendor analysis to support product design and development</li>
                <li>Participated in technical evaluation and vendor selection, identifying potential partner medical device companies: Withings, Tenovi</li>
                <li>Helped design and distribute feature surveys, and supported Conjoint Analysis efforts to prioritize product features</li>
                <li>Contributed to iterative product development using agile principles and direct input into product refinements</li>
                <li>Collaborated with clinical stakeholders and engineers to identify user pain points using the Jobs To Be Done framework</li>
            </ul>
        </VerticalTimelineElement>




        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2023 - 8/2023"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Cybersecurity Researcher - Intern
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            NASA | AMES Research Center, California USA
          </h4>
          <ul>
                <li>Gained a solid understanding of OSSEC+ software and HIDS to develop a UML diagram to illustrate the HIDS architecture in the Urban Air Mobility environment</li>
                <li>Ability to work cohesively with individuals from different backgrounds and disciplines, showcasing effective interpersonal skills and contributing to the overall success of cross-functional initiatives.</li>
                <li>Developed & implemented test plans for HIDS to address visibility of security within UAM environment</li>
                <li>Co-authored a paper on HIDS for publication with mentor and coworker</li>
            </ul>
        </VerticalTimelineElement>


        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2023 - 8/2023"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<BorderColor/>}
        >
          <h3 className="vertical-timeline-element-title">
          Publication: Aviation Technical Paper
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          Co-Located 2024 AIAA AVIATION Forum and 2024 ASCEND
          </h4>
          <ul>
              <li>Cyber Resiliency and the Implementation of a Host-Based Intrusion Detection System in an Urban Air Mobility Environment </li>
          </ul>
          <button>
                        <motion.a 
                            initial={{opacity: 0, y: 50}}
                            whileInView={{opacity: 1, y: 0, transition: {delay: 0.2, duration: 0.5}}}
                            viewport={{ once: false, amount: .5}}
                            href={require("../assets/Publication.pdf")} target="_blank" rel="noopener noreferrer" style={{ color: "black", textDecoration: "none" }}>
                            Read Publication
                        </motion.a>
          </button>
        </VerticalTimelineElement>

        
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2023 - 8/2023"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          DEIA Support - Intern
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            NASA | AMES Research Center, California USA
          </h4>
          <ul>
                <li>Identified & recommended HBCUs to technical directorates in support of HBCU technology showcase</li>
                <li>Successfully demonstrated strong team player attributes by actively engaging and fostering open communication with diverse teams across various departments.</li>
                <li>Assisted in the maintenance of distribution lists and Microsoft Teams groups</li>
                <li>Supported the coordination of recruiting engagement by developing recruiting schedules, registering recruiters, booking housing, etc.</li>
                <li>Facilitated NASA SATERN training assessments</li>
                <li>Increased engagement with underrepresented communities</li>
            </ul>
        </VerticalTimelineElement>


        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="5/2019 - 5/2025"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          User Experience Tester 
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          UserTesting | Remote, California USA 
          </h4>
          <ul>
              <li>Evaluated and advised on improving user experience and user interface design for companies like Apple, Google, and Amazon using tools such as SurveyMonkey and Tableau, resulting in enhanced user satisfaction and streamlined interfaces</li>
          </ul>
        </VerticalTimelineElement>


        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="9/2021 - Present
          "
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          CS Lab, Programming, & Mathematics Tutor
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          University of California Riverside | Riverside, California USA 
          </h4>
          <ul>
              <li>Assist students with Operating Systems Design and C++ Lab assignments. Advise on best practices. Assess and grade student coding styles and approaches. Tutoring students.</li>
          </ul>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2021 - 9/2021"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          Software Engineering - Intern
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          NSF International Research | Riverside, California USA 
          </h4>
          <ul>
              <li>Researched approximate commuting for mathematical equations and Decision-Cart-Tree image processing with Python</li>
              <li>Performed requirements analysis using JTBD framework, defining user stories and supporting the creation of technical design artifacts</li>
              <li>Acted as Scrum Master to design and implement a Minimum Viable Product</li>
          </ul>
        </VerticalTimelineElement>

      </VerticalTimeline>







      <div className="skills">

       <h1>Engagements</h1>
         <ol className="list"></ol>
      </div>
      
      <div className="experience">
        <VerticalTimeline lineColor="#b59e1f">
          <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="7/2022"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<BorderColor />}
        >
          <h3 className="vertical-timeline-element-title">
          MasterCard Cybersecurity
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Virtual Experience Program on Forage
          </h4>
          <p>Designed a phishing email simulation and Interpret phishing simulation results.</p>
        </VerticalTimelineElement>




          <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="6/2020 - 8/2020"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
          Intern Volunteer
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Remote - Dupont
          </h4>
          <p>Applied Python to perform data classification and drive automated decisioning</p>
        </VerticalTimelineElement>



          <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="10/2020 - 6/2021"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<Computer />}
        >
          <h3 className="vertical-timeline-element-title">
          Hackathon Moderator
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          University of California Riverside
          </h4>
          <p>Moderated hackers whilst coding, answering coding questions, and referring hackers to mentors.</p>
        </VerticalTimelineElement>




          <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="8/2016 - 6/2020"
          iconStyle={{ background: "#b59e1f", color: "#fff" }}
          icon={<DevicesOther />}
        >
          <h3 className="vertical-timeline-element-title">
          Technology Support Advisor
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
          Calabasas Library
          </h4>
          <p>Taught coding to children through code.org and codacademy.com. Provided network, computer, and mobile support to the elderly and children.</p>
        </VerticalTimelineElement>
        </VerticalTimeline>
      </div>


               
  


    </div>
  );
}

export default Experience;